'use client'

import { PropsWithChildren, useCallback, useMemo, useState } from 'react'

import { ClientDataComponentIdentifier } from './types'
import ClientDataComponentContext from './ClientDataComponentContext'

const ClientDataComponentProvider = (props: PropsWithChildren) => {
  const [elements, setElements] = useState<
    Partial<Record<ClientDataComponentIdentifier, HTMLElement>>
  >({})

  const [hiddenFallbackIds, setHiddenFallbackIds] = useState<ReadonlyArray<string>>([])

  const getElement = useCallback(
    (id: ClientDataComponentIdentifier) => elements[id] ?? null,
    [elements],
  )

  const setElement = useCallback(
    (id: ClientDataComponentIdentifier, element: HTMLElement | null) => {
      if (!element) return
      if (elements[id] && elements[id] === element) return

      setElements(prev => ({ ...prev, [id]: element }))
    },
    [elements],
  )

  const value = useMemo(
    () => ({ getElement, setElement, hiddenFallbackIds, setHiddenFallbackIds }),
    [getElement, setElement, hiddenFallbackIds, setHiddenFallbackIds],
  )

  return <ClientDataComponentContext.Provider {...props} value={value} />
}

export default ClientDataComponentProvider
